import { FileType } from 'common';

export const CONCOURSE_PHOTOS_FILE_TYPES: string[] = [FileType.PHOTO, FileType.ALBUM];
